var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InstallLayout',{attrs:{"show-back-btn":true,"show-exit-btn":true,"back-fn":_vm.goBack,"exit-fn":_vm.exit}})
}
var staticRenderFns = []

export { render, staticRenderFns }